var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForestal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5L19 8L17 9L21 13L18 14L22 18H13",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21V18",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13L6 11",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12L10 10",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21V8",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82322 15.9999C5.38569 15.9743 4.95909 15.8532 4.57342 15.645C4.18775 15.4367 3.85239 15.1466 3.59092 14.7948C3.32945 14.4431 3.14823 14.0383 3.05999 13.609C2.97176 13.1797 2.97866 12.7363 3.08022 12.3099C2.71769 12.008 2.43147 11.6249 2.24481 11.1916C2.05815 10.7583 1.9763 10.2872 2.00592 9.81631C2.03553 9.34547 2.17578 8.88825 2.41526 8.48177C2.65475 8.0753 2.98672 7.73104 3.38422 7.47695C3.03559 6.8576 2.91817 6.1346 3.05288 5.43676C3.18759 4.73891 3.56568 4.11156 4.11978 3.66648C4.67388 3.22139 5.36801 2.98749 6.07848 3.00644C6.78896 3.02539 7.46963 3.29596 7.99922 3.76995C8.52893 3.29671 9.20937 3.02678 9.91945 3.0082C10.6295 2.98962 11.3232 3.22359 11.8769 3.66848C12.4306 4.11336 12.8085 4.7403 12.9434 5.4377C13.0782 6.1351 12.9612 6.85772 12.6132 7.47695C13.0108 7.73096 13.3428 8.07515 13.5824 8.48158C13.822 8.88801 13.9623 9.34521 13.992 9.81606C14.0218 10.2869 13.94 10.7581 13.7534 11.1914C13.5668 11.6248 13.2807 12.008 12.9182 12.3099C13.0232 12.7507 13.0269 13.2096 12.9292 13.652C12.8315 14.0945 12.6348 14.5091 12.3539 14.8646C12.073 15.2202 11.7152 15.5075 11.3074 15.705C10.8996 15.9025 10.4523 16.005 9.99922 16.0049H5.99922L5.82322 15.9999Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestal);
export default __webpack_public_path__ + "static/media/Forestal.aaaa3877b612ece69f6406613d771c4a.svg";
export { ForwardRef as ReactComponent };